import { useTranslation } from 'react-i18next'
import { IAlabAttractivenessResponseValue } from '../@types/IAlabAttractivenessTileData'
import { useGetAttractivenessDropdownOptions } from './useGetAttractivenessDropdownOptions'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useSelectedSettings = (data: IAlabAttractivenessResponseValue) => {
  const { marketTypeOptions } = useGetAttractivenessDropdownOptions()
  const { t } = useTranslation()
  if (!data) return []

  const { settings } = data.attractiveness

  const settingsList = [{
    label: t('placeme.attractiveness.section.market_type.title'),
    value: marketTypeOptions.find(option => option.value === settings.market)!.label,
    visible: true,
  },
  ]

  return settingsList
}
